import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { Reveal } from '../components/Reveal';
import { ConfiguredForm } from '../components/ConfiguredForm';
import { contactFormConfig } from '../data/forms';
import { contactEmail, websiteUrl } from '../data/navigation';
import { partners, teamMembers } from '../data/partners';
const routes = [{
  label: 'Hiring for a role? Use the employer enquiry form',
  to: '/employers#enquiry'
}, {
  label: 'Seeking an opportunity? Register your interest',
  to: '/candidates#register'
}];
export function Contact() {
  return <>
      <PageHeader label="Contact Us" title="Let’s start a conversation." intro="Whether you’re hiring for a senior or specialist role, or exploring your next career opportunity, share a few details and we’ll take it from there." data-id="element-374" data-mp="12zs8hepwx8ee" />

      <section className="bg-white py-20 lg:py-28" data-id="element-375" data-mp="aausxjd35ppc">
        <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-12 lg:gap-12 lg:px-10" data-id="element-376" data-mp="15fyonl3kzbod">
          <Reveal className="lg:col-span-5" data-id="element-377" data-mp="19gihwdl19v58">
            <dl className="space-y-8" data-id="element-378" data-mp="19f7foi78kvg8">
              <div data-id="element-379" data-mp="1e80k14ysm1rs">
                <dt className="text-sm text-ink/60" data-id="element-380" data-mp="1e7h05ipl13b4">General enquiries</dt>
                <dd className="mt-1" data-id="element-381" data-mp="1j6twcu2cfmqd">
                  <a href={`mailto:${contactEmail}`} className="break-all font-serif text-2xl font-medium text-navy transition-colors duration-150 ease-out hover:text-gold-dark" data-id="element-382" data-mp="1j5sea5mwtzz5">
                    {contactEmail}
                  </a>
                </dd>
              </div>
              <div data-id="element-383" data-mp="vjc2msziqekr">
                <dt className="text-sm text-ink/60" data-id="element-384" data-mp="10gcan9fxhrei">Executive search team</dt>
                {[...partners, ...teamMembers].map(p => <dd key={p.email} className="mt-2 text-[15px] text-ink/80" data-id="element-385" data-mp="26vcxmpmz6z8y">
                    {p.name} —{' '}
                    <a href={`mailto:${p.email}`} className="break-all font-medium text-navy underline decoration-gold underline-offset-4" data-id="element-386" data-mp="2btxvwjio38ur">
                      {p.email}
                    </a>
                  </dd>)}
              </div>
              <div data-id="element-387" data-mp="1w59oea396ig4">
                <dt className="text-sm text-ink/60" data-id="element-388" data-mp="1w4i0zmjt7r0x">Website</dt>
                <dd className="mt-1" data-id="element-389" data-mp="1r6ghj0ih1pox">
                  <a href={websiteUrl} className="text-[15px] font-medium text-navy underline decoration-gold underline-offset-4" data-id="element-390" data-mp="1r7hwhg2lywbx">
                    risingtalentpartners.com
                  </a>
                </dd>
              </div>
            </dl>

            <ul className="mt-12 divide-y divide-ink/10 border-y border-gold/40" data-id="element-391" data-mp="1d6oxai1d3d2h">
              {routes.map(r => <li key={r.to} data-id="element-392" data-mp="18ff9zo3acltr">
                  <Link to={r.to} className="group flex items-center justify-between gap-4 py-4 text-[15px] font-medium text-navy focus-visible:outline-none focus-visible:underline" data-id="element-393" data-mp="18f6x3w75xgik">
                    {r.label}
                    <ArrowRightIcon size={16} strokeWidth={1.5} className="shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-394" data-mp="2re4wkpo7yucn" />
                  </Link>
                </li>)}
            </ul>
          </Reveal>

          <div className="lg:col-span-7" data-id="element-395" data-mp="3a54l5prsy25e">
            <ConfiguredForm config={contactFormConfig} data-id="element-396" data-mp="3a6fsfzkghs19" />
          </div>
        </div>
      </section>
    </>;
}